import * as React from 'react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { CurrencyFormatter } from '@macellan/formatter'
import { Badge, IconButton } from '@components'
import i18n from '@core/translations'
import type { EarnedItemScheduledProps } from './EarnedItem.types'
import { cn } from '@core/utils'
import EarnedItemRow from './EarnedItemRow'

const EarnedItemScheduled: React.FC<EarnedItemScheduledProps> = ({
    icon = 'ticket',
    title,
    status,
    amount,
    grantDate,
    expireDate,
    currency,
    className,
    ...props
}) => {
    const { t } = useTranslation()

    const formattedGrantDate = React.useMemo(() => {
        return dayjs(grantDate).format('DD.MM.YYYY')
    }, [grantDate])

    const formattedExpireDate = React.useMemo(() => {
        return dayjs(expireDate).format('DD.MM.YYYY')
    }, [expireDate])

    const formattedAmount = React.useMemo(() => {
        return CurrencyFormatter.format(amount, i18n.getLocale(), currency)
    }, [amount, currency])

    const statusLabel = React.useMemo(() => {
        if (status === 'waiting') return t('content_config.EarnedItem.waiting')
        return status
    }, [status, t])

    return (
        <div className={cn('flex gap-3', className)} {...props}>
            <IconButton
                as="div"
                name={icon}
                className="shrink-0 bg-semantic-background-primary after:content-none"
                color="var(--content-ink-medium)"
            />

            <div className="flex-grow space-y-2 border-b border-semantic-background-tertiary pb-5 pt-4">
                <EarnedItemRow
                    title={title}
                    titleClassName="!text-body-md-b"
                    className="pb-1"
                    LayoutRightComponent={
                        <Badge
                            className="shrink-0"
                            children={statusLabel}
                            variant="ink"
                            size="tiny"
                            disabled
                        />
                    }
                />
                <EarnedItemRow
                    title={t('content_config.EarnedItem.scheduled_amount')}
                    value={formattedAmount}
                />
                <EarnedItemRow
                    title={t('content_config.EarnedItem.grant_date')}
                    value={formattedGrantDate}
                />
                <EarnedItemRow
                    title={t('content_config.EarnedItem.expire_date')}
                    value={formattedExpireDate}
                />
            </div>
        </div>
    )
}
export default EarnedItemScheduled
